import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { SubscriptionCardV3 } from '../SubscriptionCardV3';
import styles from './SubscriptionPlanSelectorV3.css';

const cx = classnames.bind(styles);

function SubscriptionPlanSelectorV3({ className = '', plans, onSubmit, selectedSubscriptionData, selectSubscription, isPending = false, spriteVersion }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const radioGroupName = useId();

    return (
        <div className={classes}>
            <div className={styles.plans}>
                {plans.map(plan => (
                    <SubscriptionCardV3
                        subscriptionData={plan}
                        selectedSubscriptionData={selectedSubscriptionData}
                        selectSubscription={selectSubscription}
                        spriteVersion={spriteVersion}
                        name={radioGroupName}
                        key={plan.plan}
                    />
                ))}
            </div>
            <Button
                type='ink'
                label='Get my plan'
                iconRight={{ name: 'chevronRight' }}
                onClick={() => onSubmit(selectedSubscriptionData)}
                className={styles.button}
                isLoading={isPending}
                inSlide
            />
        </div>
    );
}

SubscriptionPlanSelectorV3.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    spriteVersion: PropTypes.string.isRequired
};

export {
    SubscriptionPlanSelectorV3
};
